if (!customElements.get('plp-size-atc')) {
  class PlpSizeAtc extends HTMLElement {
    connectedCallback() {
      this.variantInput = this.querySelector('[name="id"]');
      this.button = this.querySelector('[data-plp-atc]');
      this.soldOutEl = this.querySelector('[data-size-sold-out]');
      this.band = this.closest('[data-plp-band]');
      this.sizes = this.parseSizes();
      this.requiresSize = this.sizes.size > 0;

      this.handleSizeChange = this.handleSizeChange.bind(this);
      this.handleSubmit = this.handleSubmit.bind(this);

      document.addEventListener('theme:plp-size:changed', this.handleSizeChange);

      // Capture phase on the host runs before <product-form>'s bubble-phase
      // listener on the inner <form>, so the guard can cancel the add.
      this.addEventListener('submit', this.handleSubmit, true);
    }

    disconnectedCallback() {
      document.removeEventListener('theme:plp-size:changed', this.handleSizeChange);
      this.removeEventListener('submit', this.handleSubmit, true);
    }

    parseSizes() {
      const script = this.querySelector('[data-plp-sizes]');
      const sizes = new Map();
      if (!script) return sizes;

      try {
        for (const entry of JSON.parse(script.textContent)) sizes.set(entry.size, entry);
      } catch (error) {
        console.error('plp-size-atc: could not read size data', error);
      }
      return sizes;
    }

    handleSizeChange({ detail }) {
      const size = detail?.size ?? '';
      const match = size ? this.sizes.get(size) : undefined;
      const isSoldOut = Boolean(size) && !match?.available;

      if (this.variantInput) this.variantInput.value = match?.available ? String(match.id) : '';
      if (this.button) this.button.disabled = isSoldOut;

      this.syncLinks(match ? String(match.id) : '');
      this.toggle(this.soldOutEl, isSoldOut);
    }

    /* Keep the band's product links pointing at the chosen variant. The band
       element is itself the link, so it has to be included alongside any links
       nested inside it. */
    syncLinks(variantId) {
      const scope = this.band ?? this;
      const links = [...scope.querySelectorAll('[data-plp-link]')];
      if (scope.matches('[data-plp-link]')) links.push(scope);

      for (const link of links) {
        const base = link.dataset.plpHref;
        if (!base) continue;

        const url = new URL(base, window.location.origin);
        if (variantId && url.pathname.includes('/products/')) {
          url.searchParams.set('variant', variantId);
        } else {
          url.searchParams.delete('variant');
        }
        link.setAttribute('href', url.toString());
      }
    }

    /* No size chosen yet — cancel the add and let the pill ask for one. */
    handleSubmit(event) {
      if (!this.requiresSize || this.variantInput?.value) return;

      event.preventDefault();
      event.stopPropagation();

      document.dispatchEvent(new CustomEvent('theme:plp-size:requested', { bubbles: true }));
    }

    toggle(element, isVisible) {
      if (element) element.hidden = !isVisible;
    }
  }

  customElements.define('plp-size-atc', PlpSizeAtc);
}
